import api from './api.js'

const loginEndpoint = "api/nutritionists/login";
const loginAsAdminEndpoint = "api/nutritionists/login-as-admin";

export default {

  login(payload) {
    return api.post(loginEndpoint,payload);
  },
  loginAsAdmin(payload){
    return api.post(loginAsAdminEndpoint,payload);
  }
}